export default __webpack_public_path__ + "static/media/adult-banner.4a30ff12.jpg";